import { flowIdVillasureOfferFlow } from '../../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../../flows/src/hooks/useFlowsResetState';
import { pushToSelectedRiskObjects } from '../../store/redux/slices/selectionSlice';
import { useLouiseDispatch } from '../../store/redux/store';
import { setSelectionState } from '../../utils/persistUtils';

const useStartVillasureOfferFlow = (): ((uuid: string) => Promise<void>) => {
  const { initFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();
  const louiseDispatch = useLouiseDispatch();

  return async (uuid?: string) => {
    reset();

    const flowPayload = {
      company: ['pia'],
      insurance_type: ['home'],
    };

    // Hardcoded push for risk object since only 1 is possible
    louiseDispatch(pushToSelectedRiskObjects(['home']));
    if (uuid) setSelectionState(uuid, flowPayload);

    await initFlow({
      flowId: flowIdVillasureOfferFlow,
      payload: flowPayload,
      outputUrl: `/sales-conversation/offers/overview/home`,
      sessionId: uuid,
    });
  };
};

export default useStartVillasureOfferFlow;
